module.exports = __webpack_public_path__ + "img/syukyaku-top-pa001.5aa98ac7.png";